import { useState } from "react";
import Sidebar from "../../components/feature/Sidebar";
import TopBar from "../../components/feature/TopBar";
import Moodboard from "./components/Moodboard";
import DemoPlayer from "./components/DemoPlayer";
import AlbumPlanForm from "./components/AlbumPlanForm";
import HubTaskPanel from "../../components/feature/HubTaskPanel";
import { albumProjects } from "../../mocks/arHub";
import { arTasks, arCollabTasks } from "../../mocks/hubTasks";

const allArTasks = [...arTasks, ...arCollabTasks];
import { useCompany } from "../../contexts/CompanyContext";

export default function ArHub() {
  const { workspaceId } = useCompany();
  const [submitted, setSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState<"tasks" | "moodboard" | "player" | "plan">("tasks");

  const tabs = [
    { key: "tasks" as const, label: "내 할 일", icon: "ri-checkbox-multiple-line" },
    { key: "moodboard" as const, label: "무드보드", icon: "ri-image-line" },
    { key: "player" as const, label: "데모곡", icon: "ri-play-circle-line" },
    { key: "plan" as const, label: "앨범 기획서", icon: "ri-file-text-line" },
  ];

  return (
    <div className="min-h-screen bg-[#0C0C0E] flex font-sans">
      <Sidebar />
      <div className="flex-1 ml-56 flex flex-col">
        <TopBar />
        <main className="flex-1 p-5 flex flex-col gap-4 overflow-hidden" style={{ height: "calc(100vh - 48px)" }}>
          {/* Header */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#4B6CF7]/10 border border-[#4B6CF7]/20">
                <i className="ri-music-2-line text-[#7A9BFF] text-base"></i>
              </div>
              <div>
                <h2 className="text-[#F2F2F2] font-semibold text-sm">A&amp;R 크리에이티브 허브</h2>
                <p className="text-[#3D3D3D] text-xs">앨범 콘셉트 기획 · 데모곡 수급 · 아티스트 매칭</p>
              </div>
            </div>
            <div className="flex items-center gap-1.5 bg-white/[0.03] border border-white/[0.06] px-3 py-1.5 rounded-full">
              <i className="ri-folder-open-line text-[#4B6CF7]/50 text-xs"></i>
              <span className="text-[#555555] text-xs">{albumProjects.length}개 앨범 기획 중</span>
            </div>
          </div>

          {/* Tab Bar */}
          <div className="flex bg-white/[0.03] border border-white/[0.05] rounded-xl p-1 gap-1 w-fit">
            {tabs.map(tab => (
              <button key={tab.key} type="button" onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-medium cursor-pointer whitespace-nowrap transition-all ${
                  activeTab === tab.key ? "bg-[#4B6CF7]/15 text-[#7A9BFF] border border-[#4B6CF7]/20" : "text-[#444444] hover:text-[#888888]"
                }`}>
                <i className={tab.icon}></i>{tab.label}
              </button>
            ))}
          </div>

          {/* Desktop: 할 일 탭은 전체 너비, 나머지는 3컬럼 */}
          {activeTab === "tasks" && (
            <div className="flex-1 overflow-y-auto">
              <HubTaskPanel tasks={allArTasks} hubTitle="A&R" workspaceId={workspaceId} hub="ar" />
            </div>
          )}
          {/* Desktop 3-column */}
          <div className={`${activeTab === "tasks" ? "hidden" : "hidden lg:grid"} grid-cols-3 gap-4 flex-1 overflow-hidden`}>
            <div className="overflow-hidden flex flex-col"><Moodboard /></div>
            <div className="bg-[#111112] border border-white/[0.05] rounded-xl p-4 overflow-hidden flex flex-col">
              <div className="flex items-center justify-between mb-3">
                <div>
                  <h3 className="text-[#CCCCCC] font-medium text-sm">데모곡 리스트</h3>
                  <p className="text-[#555555] text-xs mt-0.5">가상 작곡가 데모 트랙 5곡</p>
                </div>
                <span className="text-[9px] bg-[#4B6CF7]/10 text-[#7A9BFF] border border-[#4B6CF7]/20 px-2 py-0.5 rounded-full">2개 신규</span>
              </div>
              <div className="flex-1 overflow-hidden"><DemoPlayer /></div>
            </div>
            <div className="bg-[#111112] border border-white/[0.05] rounded-xl p-4 overflow-hidden flex flex-col">
              <AlbumPlanForm onSubmit={() => setSubmitted(true)} />
            </div>
          </div>

          {/* Mobile */}
          <div className={`${activeTab === "tasks" ? "hidden" : "lg:hidden"} flex-1 overflow-hidden`}>
            {activeTab === "moodboard" && <Moodboard />}
            {activeTab === "player" && (
              <div className="bg-[#111112] border border-white/[0.05] rounded-xl p-4 h-full">
                <h3 className="text-[#CCCCCC] font-medium text-sm mb-3">데모곡 리스트</h3>
                <DemoPlayer />
              </div>
            )}
            {activeTab === "plan" && (
              <div className="bg-[#111112] border border-white/[0.05] rounded-xl p-4 h-full">
                <AlbumPlanForm onSubmit={() => setSubmitted(true)} />
              </div>
            )}
          </div>

          {submitted && (
            <div className="fixed bottom-6 right-6 bg-[#4B6CF7] text-white text-sm px-4 py-3 rounded-xl flex items-center gap-2 z-50">
              <i className="ri-check-double-line text-lg"></i>기획서가 AI 프로듀서에게 제출되었습니다!
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
